import React from 'react'
import { NavLink } from 'react-router'

import { useGlobalSearch } from '../hooks/useGlobalSearch'

const SearchButton: React.FC = () => {
  const globalSearch = useGlobalSearch()

  return (
    <NavLink
      to="#"
      className="nav-link text-muted"
      onClick={() => {
        globalSearch.show()

        // Wrap in setTimeout to ensure the search input is visible when we
        // try to focus on it
        setTimeout(() => {
          globalSearch.focus()
        })
      }}
    >
      Search
    </NavLink>
  )
}

export default SearchButton
